export default "__VITE_ASSET__reUH_IGt__"